<div class="forgot-password-confirmation-form-wrapper">
  <img src="./assets/images/logo.svg" class="logo" alt="logo" />
  <xos-forgot-password-confirmation-form></xos-forgot-password-confirmation-form>
</div>
